import {ChartModel} from '@xh/hoist/cmp/chart';
import {HoistModel, managed} from '@xh/hoist/core';
import {runInAction} from '@xh/hoist/mobx';

export class AllocationWidgetModel extends HoistModel {
    @managed chartModel = new ChartModel({highchartsConfig: this.createChartModel()});

    override onLinked() {
        super.onLinked();

        this.updateChart();
    }

    private updateChart() {
        const allocationSeries = {
            name: 'Share',
            colorByPoint: true,
            data: [
                {
                    name: 'US Equity',
                    y: 60
                },
                {
                    name: 'exUS',
                    y: 19
                },
                {
                    name: 'Cash',
                    y: 1.8
                },
                {
                    name: 'Bonds',
                    y: 2.2
                },
                {
                    name: 'Real Estate',
                    y: 10
                },
                {
                    name: 'Precious Metals',
                    y: 5
                }
            ]
        };

        runInAction(() => {
            this.chartModel.setSeries([allocationSeries]);
        });
    }

    private createChartModel() {
        return {
            chart: {type: 'pie', animation: false},
            // One fixed color per asset class, picked to stay apart on both themes.
            colors: ['#58a6ff', '#a371f7', '#6b7785', '#d29922', '#3fb950', '#f5c044'],
            plotOptions: {
                pie: {
                    animation: false,
                    innerSize: '62%',
                    borderWidth: 1,
                    borderColor: 'rgba(0, 0, 0, 0.35)',
                    dataLabels: {
                        format: '{point.name}<br/><span style="opacity: 0.7">{point.percentage:.1f}%</span>',
                        distance: 14,
                        connectorWidth: 1,
                        style: {fontWeight: 'normal', textOutline: 'none'}
                    }
                }
            },
            tooltip: {
                valueSuffix: '%'
            }
        };
    }
}
